import { render, staticRenderFns } from "./RegisterResubmit.vue?vue&type=template&id=383d0e45&scoped=true&"
import script from "./RegisterResubmit.vue?vue&type=script&lang=ts&"
export * from "./RegisterResubmit.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterResubmit.vue?vue&type=style&index=0&id=383d0e45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d0e45",
  null
  
)

export default component.exports